module.exports = __webpack_public_path__ + "img/vuelos7.fd0e2514.jpg";